export type WindowEventMessage<T = undefined> = {
  source: string
  event: string
  payload: T
}

export enum PostMessageType {
  popup,
  iframe,
}
